import React, { useContext } from 'react';
import AppMenu from './AppMenu';
import { LayoutContext } from './context/layoutcontext';
import { MenuProvider } from './context/menucontext';
import { LayoutState } from '../types/layout';
import { Link, useNavigate } from 'react-router-dom';
import { useAppSelector } from 'app/config/store';

const AppSidebar = () => {
  const { setLayoutState } = useContext(LayoutContext);
  const navigate = useNavigate();
  const anchor = () => {
    setLayoutState((prevLayoutState: LayoutState) => ({
      ...prevLayoutState,
      anchored: !prevLayoutState.anchored,
    }));
  };

  const version = useAppSelector(state => state.applicationProfile.version);

  return (
    <>
      <div className="sidebar-header">
        <Link to="/">
          <span style={{ display: 'flex' }}>
            <h1 className="app-logo">
              <div className="logo" onClick={() => navigate('/')}>
                <img src="public/images/favicon.ico" alt="Logo" style={{ height: '40px' }} />
              </div>
            </h1>
          </span>
        </Link>
        <button className="layout-sidebar-anchor p-link z-2 mb-2" type="button" onClick={anchor}></button>
      </div>

      <div className="layout-menu-container">
        <MenuProvider>
          <AppMenu />
        </MenuProvider>
      </div>
    </>
  );
};

export default AppSidebar;
